module.exports = __webpack_public_path__ + "static/img/5.3631c3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/5.png
// module id = 7zP8
// module chunks = 0